import React, { useEffect, useState } from 'react';
import domtoimage from 'dom-to-image';
import { jsPDF } from "jspdf";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { Box, CircularProgress, Typography } from '@material-ui/core';
import TimelineIcon from '@material-ui/icons/Timeline';

import RepLIChart from "../../desktop/repli/RepLIChart.component";

import useStyles from './Downloader.style'
import { MobileButton, MobileOutlinedButton, MobileRegularPage } from '../../../components';
import Cookies from 'universal-cookie';


const cookies = new Cookies();
const Downloader = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [sending, setSending] = useState(false);
    const [sendResult, setSendResult] = useState('');

    const [healthProfile, setHealthProfile] = useState();

    useEffect(() => {
        const getProfile = async () => {
            try {
                let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT_PROFILE}`, {
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    },
                });
                let json = await response.json();
                if (!response.ok) {
                    console.log(json.message);
                    return;
                };
                setHealthProfile(json);
            } catch (error) {
                console.log(error);
            };
        };

        getProfile();
    }, []);

    const getPostParameters = (pdf) => {
        let result = new FormData()
        result.append('pdf', pdf.output('blob', 'myrepli.pdf'));

        return result;
    }

    const handleSendPDF = async e => {
        e.preventDefault();

        if (!healthProfile.dateOfBirth) {
            setSendResult('Please, fill your Profile first!');
            return;
        };

        setSending(true);
        setSendResult('');
        try {
            let chartNode = document.getElementById('repliChart')
            let repliImage = await domtoimage.toPng(chartNode);

            let pdf = new jsPDF({
                orientation: 'landscape'
            });
            pdf.setFontSize(22);
            pdf.text(`${healthProfile.firstName}'s My RepLI`, 10, 10);
            pdf.addImage(repliImage, 'PNG', 10, 20);

            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PATIENT}/mailRepLI`, {
                method: 'post',
                body: getPostParameters(pdf),
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                }
            });

            setSendResult(
                response.ok
                    ? 'RepLI sent successfully'
                    : 'Sorry, something went wrong and we counldn\'t send the email'
            );
        } catch (error) {
            console.log(error);
            setSendResult('Sorry, something went wrong and we counldn\'t send the email');
        } finally {
            setSending(false);
        }
    }

    const SendingResultComponent = props => {
        if (!props.result) return null;
        return (
            <Box className={classes.savingInfo}>
                {props.result}
            </Box>
        );
    }

    return (
        <MobileRegularPage>
            <Box className={classes.iconSection}>
                <TimelineIcon className={classes.icon} />
            </Box>
            <Box className={classes.textSection}>
                <Typography component="div" className={classes.text}>
                    Here you can send a RepLI Chart to your email
                </Typography>
            </Box>
            {
                sending &&
                <Box className={classes.savingInfo}>
                    Sending email&nbsp;&nbsp;&nbsp;&nbsp;
                    <CircularProgress color="inherit" />
                </Box>
            }
            <SendingResultComponent result={sendResult} />
            <Box className={classes.footer}>
                <MobileButton label="Send Email" onClick={handleSendPDF} disabled={sending} />
                <MobileOutlinedButton label={t('common.form.button.back')} component={RouterLink} to="/app/dashboard" />
            </Box>
            <div className={classes.chartContainer}>
                <div id="repliChart">
                    {
                        healthProfile &&
                        <RepLIChart profile={healthProfile} />
                    }
                </div>
            </div>
        </MobileRegularPage>
    );
};

export default Downloader;